/* Sequoia Fitness | Website: https://www.sequoia.fitness | Author: Ali Hosseini | Copyright (c) 2026 sequoia.fitness. All rights reserved. */
/* Designed and developed by Pouria Shabani | https://linkedin.com/in/pouriashabani */

import { useEffect, useRef, useState } from 'react'
import { APP_URL, ENAMAD_URL, NODES, ROOT } from '../data/assistantChips.js'
import { OFFICE_NOTE, isOfficeOpen } from '../lib/officeHours.js'

const bulletText = (b) => (typeof b === 'string' ? b : `${b.b} ${b.t}`)

export default function AssistantChat() {
  const [at, setAt] = useState('root')
  const bodyRef = useRef(null)

  useEffect(() => {
    if (bodyRef.current) bodyRef.current.scrollTop = 0
  }, [at])

  const node = at === 'root' ? ROOT : NODES[at]
  const options = node.options || []

  return (
    <div className="seq-fab-body" ref={bodyRef}>
      <div className="seq-fab-bubble">{node.text}</div>
      {node.bullets && (
        <ul className="seq-fab-list">
          {node.bullets.map((b, i) => (
            <li key={i}>{bulletText(b)}</li>
          ))}
        </ul>
      )}
      {node.enamad && (
        <a className="seq-fab-seal" href={ENAMAD_URL} target="_blank" rel="nofollow noreferrer" aria-label="نماد اعتماد الکترونیکی (اینماد)">
          <img src="/a/enamad.webp" alt="" width="125" height="136" loading="lazy" decoding="async" />
        </a>
      )}
      {node.sub && <p className="seq-fab-sub">{node.sub}</p>}
      {node.links && (
        <div className="seq-fab-links">
          {node.links.map((l) => {
            const locked = l.officeHours && !isOfficeOpen()
            const inner = (
              <>
                {l.vcard ? (
                  <span className="pg-link__ico seq-fab-link-ico" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="9" cy="8" r="3.5" />
                      <path d="M2.5 20c0-3.6 2.9-6 6.5-6s6.5 2.4 6.5 6" />
                      <path d="M19 6v6M16 9h6" />
                    </svg>
                  </span>
                ) : (
                  <img className="seq-fab-link-img" src={l.icon} alt="" width="40" height="40" loading="lazy" />
                )}
                <span className="seq-fab-link-tx">
                  <span className="seq-fab-link-t">{l.label}</span>
                  <span className="seq-fab-link-h">{l.handle}</span>
                </span>
                <span className="seq-fab-link-a">{locked ? 'خارج از ساعت کاری' : l.action}</span>
              </>
            )
            return locked ? (
              <span className="seq-fab-link seq-fab-link-locked" key={l.label}>
                {inner}
              </span>
            ) : (
              <a className="seq-fab-link" key={l.label} href={l.url} {...(l.vcard ? { download: true } : { target: '_blank', rel: 'noreferrer' })}>
                {inner}
              </a>
            )
          })}
          {node.links.some((l) => l.officeHours) && !isOfficeOpen() && <p className="seq-fab-sub">{OFFICE_NOTE}</p>}
        </div>
      )}
      <div className="seq-fab-chips">
        {options.map((o) => (
          <button className="seq-fab-chip" type="button" key={o.to + o.label} onClick={() => setAt(o.to)}>
            {o.label}
          </button>
        ))}
        {node.nav && (
          <a className="seq-fab-chip seq-fab-chip-go" href={APP_URL + node.nav.path} target="_blank" rel="noreferrer">
            {node.nav.label}
          </a>
        )}
        {at !== 'root' && (
          <button className="seq-fab-chip" type="button" onClick={() => setAt('root')}>
            برگرد به منوی اصلی
          </button>
        )}
      </div>
    </div>
  )
}
